import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";
import {AUTH_TIPE} from "../constants/AuthConstant";

const pegawaiDokumenService = {}

pegawaiDokumenService.data = function (data = '') {
    return fetch({
        url: '/transaksi/pegawai_dokumen/data',
        method: 'post',
        data: data,
        headers: {
            "x-api-key": X_API_KEY,
            "x-admin": localStorage.getItem(AUTH_TIPE)
        }
    })
}

pegawaiDokumenService.store = function (data) {
    return fetch({
        url: '/transaksi/pegawai_dokumen/store',
        method: 'post',
        data: data,
        headers: {
            "x-api-key": X_API_KEY,
            "x-admin": localStorage.getItem(AUTH_TIPE),
            'Content-Type': 'multipart/form-data'
        }
    })
}

pegawaiDokumenService.delete = function (data) {
    return fetch({
        url: '/transaksi/pegawai_dokumen/delete',
        method: 'post',
        data: data,
        headers: {
            "x-api-key": X_API_KEY,
            "x-admin": localStorage.getItem(AUTH_TIPE)
        }
    })
}

export default pegawaiDokumenService;
